/** @format */

// 状态，(00：启用 ，01：停用)

export enum chargingpileStatus {
  Open = '00',
  Stop = '01'
}

export const chargingpileStatusMap: {
  [key: string]: string;
} = {
  [chargingpileStatus.Open]: '启用',
  [chargingpileStatus.Stop]: '停用'
};
//充电时长是否叠加 (00:叠加，01：不叠加)
export enum allowCumsum {
  Yes = '00',
  No = '01'
}

export const allowCumsumMap: {
  [key: string]: string;
} = {
  [allowCumsum.Yes]: '是',
  [allowCumsum.No]: '否'
};
// 优惠类型 00时长 01金额
export enum allowTypeCumsum {
  shichang = '00',
  jine = '01'
}

export const allowTypeMap: {
  [key: string]: string;
} = {
  [allowTypeCumsum.shichang]: '时长',
  [allowTypeCumsum.jine]: '金额'
};
